import React from 'react';
import PropTypes from 'prop-types';

export const Icon = ({ headerIcon, iconName }) => {
    const parent = headerIcon ? 'lightbox__header-icon' : 'icon-container';
    return (
        <span className={`${parent} ${iconName}`}></span>
    );
};

Icon.propTypes = {
    iconName: PropTypes.string,
    headerIcon: PropTypes.bool
};

export default Icon;